import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import s from './InputErrorMessage.scss';
/**
 * An error message! Meant to follow an input field.
 */
var InputErrorMessage = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("span", __assign({ className: c(s['root'], className), "aria-live": "assertive" }, rest), children));
};
InputErrorMessage.displayName = 'InputErrorMessage';
export default InputErrorMessage;
//# sourceMappingURL=InputErrorMessage.js.map